import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

class TinyLoader extends React.Component {
  
  render() {
    return <span className="tiny-loader"><FontAwesomeIcon icon={faSpinner} size="1x" spin/></span>
  }
}

export default TinyLoader;



// WEBPACK FOOTER //
// ./src/views/Components/Loader/TinyLoader.js